import { DEV_MODE } from './cob.devmode.js';

export default function(core){

   const loadedScripts = [];
   const loadedCSS = [];

   return {

      afterDeps: function(deps, init){
         var inited = false;

         if( deps.every(function(dep){ return typeof window[dep] !== 'undefined' }) ){
            setTimeout(() => init(), 0); //don't release the Kraken

         } else core.subscribe('custom:script-loaded', function(){
            if( !inited  && deps.every(function(dep){ return typeof window[dep] !== 'undefined' }) ){
               inited = true;
               init();
            }
         });
      },

      loadScript: function(url, callback) {
         DEV_MODE && window.console.log('loadScript', url, loadedScripts[url]);
         if(!loadedScripts[url]) {
            // Adding the script tag to the head as suggested before
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;

            // Then bind the event to the callback function.
            // There are several events for cross browser compatibility.
            script.onreadystatechange = callback;
            script.onload = () => {
               core.publish('custom:script-loaded', url);
               if( typeof callback === 'function') callback();
            };

            // Fire the loading
            head.appendChild(script);
            loadedScripts[url] = true;
         }
      },

      loadCSS: function(url) {
         DEV_MODE && window.console.log('loadCSS', url, loadedCSS[url]);
         if(!loadedCSS[url]) {
            var head  = document.getElementsByTagName('head')[0];
            var link  = document.createElement('link');
            link.rel  = 'stylesheet';
            link.type = 'text/css';
            link.href = url;
            link.media = 'all';
            head.appendChild(link);
            loadedCSS[url] = true;
         }
      }
   }
}
